import React,{Component} from 'react';
class Head extends Component{

    render(){
        console.log('url(\''+this.props.src+'\')')
        return (
            <div style={{backgroundImage:'url(\''+this.props.src+'\')',backgroundSize:'cover',height:'400px',
                backgroundPositionX: 'center',boxShadow: '0px 10px 10px #888888',
                backgroundPositionY: 'top',textAlign:'center'}}>
                <table align="center" style={{verticalAlign:'medium',height:'100%'}}>
                    <tbody>
                    <tr><td><span  style={{textShadow:'0px 0px 30px #ff5b5b',color: '#fbfbfb',fontSize: '50px'}}>{this.props.title}</span></td></tr>
                    <tr><td><h5  style={{textShadow:'0px 0px 30px #ff5b5b',color: '#fbfbfb'}}>
                        {this.props.sentence}
                    </h5></td></tr>
                    </tbody>
                </table>

            </div>
        )
    }

}
export default Head;


// WEBPACK FOOTER //
// ./src/Compent/page/Head.js